// InteliChat adapter: account context.
// Wraps the native Chatwoot account composable + Vuex getters so
// InteliChat surfaces never couple to Vuex internals directly
// (an upstream Vuex->Pinia move only touches this file).
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';

export function useInteliAccount() {
  const { accountId, currentAccount, accountScopedUrl } = useAccount();

  const userAccounts = useMapGetter('getUserAccounts');

  const sortedAccounts = computed(() =>
    [...(userAccounts.value || [])].sort((a, b) =>
      (a.name || '').localeCompare(b.name || '')
    )
  );

  const hasMultipleAccounts = computed(() => sortedAccounts.value.length > 1);

  const accountName = computed(() => currentAccount.value?.name || '');

  // Full reload on account switch (native behavior - re-fetches the
  // whole account context + re-subscribes realtime). Lands back inside
  // InteliChat on the target account.
  const switchAccount = newAccountId => {
    if (Number(newAccountId) === accountId.value) return;
    window.location.href = `/app/accounts/${newAccountId}/intelichat/today`;
  };

  return {
    accountId,
    currentAccount,
    accountName,
    sortedAccounts,
    hasMultipleAccounts,
    switchAccount,
    accountScopedUrl,
  };
}
